import { render, staticRenderFns } from "./SceneFAB.vue?vue&type=template&id=54faaaaf&scoped=true&"
import script from "./SceneFAB.vue?vue&type=script&lang=js&"
export * from "./SceneFAB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54faaaaf",
  null
  
)

export default component.exports